export default __webpack_public_path__ + "static/media/violin.d84f2b15.wav";